import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import device from './modules/device'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    device,
    user
  },
  getters
})

window.store = store

export default store



// WEBPACK FOOTER //
// ./src/store/index.js